import { render, staticRenderFns } from "./pluginUpload.vue?vue&type=template&id=365c0f46&scoped=true"
import script from "./pluginUpload.vue?vue&type=script&lang=js"
export * from "./pluginUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365c0f46",
  null
  
)

export default component.exports